import React from 'react';
import { Link } from 'react-router-dom';

function Header() {
  // --- STYLES ---

  const headerStyle = {
    backgroundColor: '#ffffff', // UPDATED: Changed to a light background
    padding: '20px 5%',
    color: '#3b5c7cff', // UPDATED: Dark text color for readability
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    boxShadow: '0 2px 4px rgba(0,0,0,0.08)',
    // NEW: Set the positioning context for the centered title
    position: 'relative', 
  };

  // Styles for the left side (Logo)
  const leftLinkStyle = {
    display: 'flex',
    alignItems: 'center',
    textDecoration: 'none',
  };

  const logoStyle = {
    height: '40px',
  };
  
  // NEW: Styles for the centered title
  const titleStyle = {
    fontSize: '2.5rem',
    margin: 0,
    fontWeight: '600',
    color: '#133e69ff',
    // --- The Magic for Centering ---
    position: 'absolute',
    left: '50%',
    transform: 'translateX(-50%)', // This perfectly centers the element
  };

  // Styles for the navigation links on the right
  const navLinkStyle = {
    color: '#007bff', // Blue link color
    textDecoration: 'none',
    fontSize: '1rem',
    fontWeight: '500',
    padding: '8px 12px',
    borderRadius: '5px',
    transition: 'background-color 0.2s ease-in-out',
  };

  // --- RENDER ---
  return (
    <header style={headerStyle}>
      {/* --- Left Side: Logo only --- */}
      <Link to="/" style={leftLinkStyle}>
        <img src="/logo.png" alt="Company Logo" style={logoStyle} />
      </Link>
      
      {/* --- Center: The Title --- */}
      <h1 style={titleStyle}>
        Omkrown Database Management
      </h1>
      
      {/* --- Right Side: Navigation --- */}
      <nav>
        <Link to="/" style={navLinkStyle} 
              onMouseOver={e => e.currentTarget.style.backgroundColor = 'rgba(0, 123, 255, 0.1)'}
              onMouseOut={e => e.currentTarget.style.backgroundColor = 'transparent'}>
          Dashboard
        </Link>
      </nav>
    </header>
  );
}

export default Header;